import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import StyledCounterContainer from 'common/theme/counter/StyledCounterContainer';

/**
 * Fila de cards-counter de sesión (Programadas / Pendientes / Completadas / Ausencias…).
 * Clickeables: al pulsar una, el panel derecho muestra la lista filtrada (modo 'list').
 * La card activa enciende un borde de su color semántico.
 */
function SessionCounters({ counters, activeKey = null, onSelect = null }) {
  return (
    <Grid container spacing={{ xs: 1.5, md: 2 }}>
      {counters.map((c) => {
        const isActive = activeKey === c.key;
        const clickable = Boolean(onSelect) && !c.disabled;
        return (
          <Grid xs={6} md={3} key={c.key}>
            <StyledCounterContainer
              clickable={clickable}
              onClick={clickable ? () => onSelect(c.key) : undefined}
              sx={isActive ? { borderColor: `${c.color} !important`, boxShadow: `0 0 0 1px ${c.color}` } : undefined}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '12px',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: c.color,
                    backgroundColor: `${c.color}22`
                  }}
                >
                  {c.icon}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1 }}>{c.value}</Typography>
                  {/* Sin noWrap: en móvil el label/sub pueden ocupar 2 líneas (la card crece, no recorta). */}
                  <Typography sx={{ fontWeight: 700, lineHeight: 1.2, fontSize: { xs: '0.82rem', sm: '0.875rem' } }}>{c.label}</Typography>
                  {c.sub && (
                    <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.25 }}>{c.sub}</Typography>
                  )}
                </Box>
              </Stack>
            </StyledCounterContainer>
          </Grid>
        );
      })}
    </Grid>
  );
}

SessionCounters.propTypes = {
  counters: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    sub: PropTypes.string,
    color: PropTypes.string.isRequired,
    icon: PropTypes.node,
    disabled: PropTypes.bool
  })).isRequired,
  activeKey: PropTypes.string,
  onSelect: PropTypes.func
};

export default SessionCounters;
